import { API_URL, SITE_CODE, SITE_ID } from "./config";
import axios from "axios";

export const getTableSurficial = (data, callback) => {
  axios
    .get(
      `${API_URL}/api/surficial/tabled_marker_observations/${SITE_CODE}/${data.startDate}/${data.endDate}`
    )
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const getSurficialData = (data, callback) => {
  axios
    .get(
      `${API_URL}/api/surficial/get_surficial_plot_data/${SITE_ID}/${data.startDate}/${data.endDate}`
    )
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const sendMeasurement = (data, callback) => {
  axios
    .post(`${API_URL}/api/surficial/insert_web`, data)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const deletePrevMeasurement = (data, callback) => {
  axios
    .post(`${API_URL}/api/surficial/delete_prev_measurement`, { mo_id: data })
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const deleteMeasurement = (data, callback) => {
  axios
    .post(`${API_URL}/api/surficial/delete_surficial_data`, {
      quantity: "all",
      id: data,
    })
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};

export const getStaffs = (callback) => {
  axios
    .get(`${API_URL}/api/monitoring/surficial_measurers/${SITE_CODE}`)
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {});
};
